import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; 
import styles from './AppTextToggle.module.scss';

// Component to toggle text visibility
const AppTextToggle = ({ message }) => {

    const [isVisible, setIsVisible] = useState(false);

    const toggleMessageVisibility = () => {
        setIsVisible((prev) => !prev);
    };

    return (
        <div className={styles.toggleableMessage}>
            <span className={styles.messageText}>
                {isVisible ? message : '••••••••'}
            </span>
            <button
                className={styles.toggleButton}
                onClick={toggleMessageVisibility}
                title={isVisible ? 'Hide message' : 'Show message'}
            >
                {isVisible ? <FaEye /> : <FaEyeSlash />}
            </button>
        </div>
    );
};

export default AppTextToggle;
